


<div class="storelistwrapper">
  <div class="text-heading-3 important-content">Important actions</div>
  <div>
    <ul class="nav nav-pills mb-3" id="homepills" role="tablist">
      <li class="nav-item" role="presentation">
        <button class="nav-link" [class.active]="activeTab === 'alerts'" (click)="setActiveTab('alerts')" type="button" role="tab" aria-controls="pills-home" aria-selected="false">
          <div><img src="../../../assets/images/storelist/alerts.svg" alt="alerts"></div>
          <div class="headerName text-heading-6">Alerts & Notifications</div>
        </button>
      </li>
      <li class="nav-item" role="presentation">
        <button class="nav-link" [class.active]="activeTab === 'stores'" (click)="setActiveTab('stores')" type="button" role="tab" aria-controls="pills-profile" aria-selected="false">
         <div><img src="../../../assets/images/storelist/stores.svg" alt="stores"></div> 
         <div class="headerName text-heading-6">Stores</div>
        </button>
      </li>
      <li class="nav-item" role="presentation">
        <button class="nav-link" [class.active]="activeTab === 'warehouse'" (click)="setActiveTab('warehouse')" type="button" role="tab" aria-controls="pills-contact" aria-selected="false">
         <div><img src="../../../assets/images/storelist/warehouse.svg"></div>
         <div class="headerName text-heading-6">Warehouse</div>
        </button>
      </li>
    </ul>
    <div class="tab-content" id="pills-tabContent"> 
      <div class="tab-pane fade" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">
        <app-alerts-notify *ngIf="activeTab === 'alerts'"></app-alerts-notify>
      </div>
      <div class="tab-pane fade show active" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab">
        <div class="storelistwrapper"> 
          <div class="storecount-content text-heading-3">Stores - {{ totalStoreCount }}</div>
          <div class="stroelistwrapper">
             <div class="storewrapper" *ngFor="let store of storeDetails">
               <div class="storename-content text-heading-4 flex"><img class="storecmpny" src="../../../../assets/images/storelist/mpn.svg" alt="storename">{{store.name}}</div>
               <div class="storesection">
        
                 <div class="stockswrapper"> 
                   <a [routerLink]="['/home/stores/list']" [queryParams]="{ id: store.id }">
                     <div class="stocks-content"><img class="stocksimg" src="../../../../assets/images/storelist/stocks.svg" alt="" >Stocks</div>
                     <div class="stockcount text-para">{{store.stocks}}</div>
                   </a>
                 </div>
                 <!-- <div class="cabinetswrapper">
                    <a [routerLink]="['/home/stores/'+ store.id +'/devices']" [queryParams]="{ id: store.id }">
                      <div class="stocks-content"><img class="stocksimg" src="../../../../assets/images/storelist/cabinet.svg" alt="" >Devices</div>
                      <div class="stockcount">{{store.cabinets}}</div>
                    </a>
                 </div> -->
                 <div class="cabinetswrapper">
                  <a [routerLink]="getDeviceLink(store.id)" [queryParams]="{ id: store.id }">
                    <div class="stocks-content">
                      <img class="stocksimg" src="../../../../assets/images/storelist/cabinet.svg" alt="Devices">
                      Devices
                    </div>
                    <div class="stockcount">{{store.cabinets}}</div>
                  </a>
                </div>
               </div>
             </div>
          </div>
        </div>
      </div>
      <div class="tab-pane fade" id="pills-contact" role="tabpanel" aria-labelledby="pills-contact-tab">
        <app-stock-warehouse *ngIf="activeTab === 'warehouse'"></app-stock-warehouse>
      </div>
    </div>
  </div>
</div>
